"use client"

import { Toaster } from "sonner"

export function ToastProvider() {
  return (
    <Toaster
      position="bottom-right"
      richColors
      closeButton={false}
      expand={true}
      offset="100px"
      toastOptions={{
        unstyled: false,
        className: 'toast-custom',
        style: {
          fontFamily: 'var(--font-roboto)',
        },
        classNames: {
          toast: 'group toast-base',
          title: 'toast-title',
          description: 'toast-description',
          actionButton: 'toast-action',
          cancelButton: 'toast-cancel',
          closeButton: 'toast-close',
          success: 'toast-success',
          error: 'toast-error',
          warning: 'toast-warning',
          info: 'toast-info',
        },
      }}
    />
  )
}
